import { render, staticRenderFns } from "./_phones.vue?vue&type=template&id=5e0fada2"
import script from "./_phones.vue?vue&type=script&lang=js"
export * from "./_phones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports